export default "__VITE_ASSET__DEdHfdOd__"